<template>
<div class="h-full" v-if="!headerType">
	<top-app-bar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
			staticMode="true"
		>
		</top-app-bar>
	<div class="d-flex h-full flex-column">
	 <top-app-bar-drawer></top-app-bar-drawer>
		<main class="main-wrapper flex-grow-1" v-if="surveyData">
		  <div ref="surveyHeader">
			  <view-header-insight :surveyData="surveyData"></view-header-insight>
			</div>
			<div class="container container--narrow pdt-30 pdb-50">
			  <div class="t-headline11 font-m l-spacing72 t-line-h-24">{{$t('1818')}}</div>
				<div class="d-flex align-items-center mgt-8 ">
					<img src="/images/survey/participant.svg" alt="" class="w-14 mgr-8">
					<span class="t-color-bodyGrayA t-body6 font-r l-spacing45 t-line-h-22" v-if="surveyData">
					  {{$t("1819", { str:surveyData.submitCount})}}
					</span>
				</div>
				<div v-for="(survey, index) in surveyData.stats" :key="index">
				<div class="mdc-card mgb-16 mgt-16 pda-24 cursor-pointer" v-if="survey && survey.questionType && (survey.questionType.value=='CHOICE_SINGLE' || survey.questionType.value=='CHOICE_MULTIPLE')" >
					<div class="t-headline7 font-r l-spacing54 t-line-h-24 d-flex -align-items-center">
					  {{index+1}}. {{survey.contents.text}}
					  <img src="/images/survey/survey-point.svg" alt="" class="pdl-4 w-7 d-inline" v-if="survey.essential=== true">
					</div>
					<div class="" v-for="(information, index1) in survey.statsDto[0].information" :key="index1">
						<div class="t-body6 mgt-18 t-color-bodyGrayA l-spacing-45 t-line-4-22">{{information.content}}</div>
						<div class="t-subtitle2 font-rb mgb-7 t-nowrap" v-if="information.rate>80" :style="`padding-left:calc(${information.rate}% - 3%);`">{{$t("1820", { str:information.rate})}}</div>
						<div class="t-subtitle2 font-rb mgb-7 t-nowrap" v-else :style="`padding-left:calc(${information.rate}%);`">{{$t("1820", { str:information.rate})}}</div>
						<div class="bg-iconInactiveText position-relative h-2 b-radius4">
							<div class="bg-iconInactive position-absolute h-6 survey-percentage" :style="`width: ${information.rate}%;`">
							</div>
						</div>
						<div class="t-body3 t-color-iconInactive mgt-15 d-flex justify-content-end font-r">
							{{$t("1821", { str1:information.count,str2:survey.statsDto[0].total})}}
						</div>
						<div class="mgt-16"> </div>
					</div>
				</div>
				<div class="mdc-card mgt-24 pda-24" v-if="survey && survey.questionType && survey.questionType.value=='SHORT_ANSWER'">
					<div class="t-headline7 font-r l-spacing54 t-line-h-24 d-flex -align-items-center">{{index+1}}. {{survey.contents.text}}
						<img src="/images/survey/survey-point.svg" alt="" class="pdl-4 w-7 d-inline" v-if="survey.essential=== true">
					</div>
					<div class="t-body6 mgt-16 t-color-bodyGrayA l-spacing-45 t-line-4-22">
					  {{$t('1822')}}
					</div>
				</div>
				<div class="mdc-card mgt-24" v-if="survey && survey.questionType && survey.questionType.value=='STARS'">
					<div class="pda-24">
						<div class="t-headline7 font-r l-spacing54 t-line-h-24 d-flex -align-items-center">
						  {{index+1}}. {{survey.contents.text}}<img
							src="/images/survey/survey-point.svg" alt="" class="pdl-4 w-7 d-inline" v-if="survey.essential=== true">
						</div>
						<div class="d-flex mgt-16">
							<div class="d-flex flex-column">
								<div class="pdl-2 font-rb survey-rank">{{survey.statsDto[0].avg}}</div>
								<div class="t-body3 t-color-bodyGrayA font-r l-spacing42 t-center mgt-8">{{$t('1823')}}</div>
							</div>
							<div class="flex-grow-1 d-flex flex-column">
								<div class="flex-grow-1 d-flex align-items-baseline mgl-10 h-6" v-for="(star, index2) in survey.statsDto[0].information" :key="index2">
									<div class="w-30 t-right">
									  <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-30 d-inline" v-if="star.rank==5">
									  <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-24 d-inline" v-if="star.rank==4">
									  <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-18 d-inline" v-if="star.rank==3">
									  <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-12 d-inline" v-if="star.rank==2">
									  <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-6 d-inline"  v-if="star.rank==1">
									</div>
									<div class="flex-grow-1 mgl-6">
										<div class="bg-iconInactiveText position-relative h-2 b-radius4">
											<div class="bg-iconInactive position-absolute h-2 star-percentage"
												:style="`width: ${star.count*20}%;`">
											</div>
										</div>
									</div>
								</div>
								<div class="flex-grow-1 d-flex align-items-baseline justify-content-end t-color-bodyGrayA t-body3 font-r mgt-24">
								   {{$t("1824", { str:survey.statsDto[0].total})}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mdc-card mgt-24 mgb-24 pda-24" v-if="survey && survey.questionType && survey.questionType.value=='RANKING'">
					<div class="t-headline7 font-r l-spacing54 t-line-h-24 d-flex -align-items-center">
					  {{index+1}}. {{survey.contents.text}}<img
							src="/images/survey/survey-point.svg" alt="" class="w-16 d-inline" v-if="survey.essential=== true">
					</div>
					<div v-for="(answerChoice, index2) in survey.statsDto" :key="index2">
					<div class="t-body6 mgt-16 t-color-bodyGrayA l-spacing-45 t-line-4-22">{{answerChoice.choiceAnswerName}}</div>
					<div class="mgt-24 d-flex" v-if="answerChoice && answerChoice.information && answerChoice.information.length>0">
						<div class="d-flex flex-column">
							<div class="d-flex align-items-center mgb-16"  v-for="(informationRank, index3) in answerChoice.information" :key="index3">
								<span class="mgr-16 w-41 h-6 b-radius2"  v-if="index3==0" style="background:#68cec6;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22"  v-if="index3==0">{{$t('3173',{str:index3+1})}} </span>
						   
								<span class="mgr-16 w-41 h-6 b-radius2" v-if="index3==1" style="background:#f5d479;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==1">{{$t('3173',{str:index3+1})}}  </span>

								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#737acf;" v-if="index3==2"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==2">{{$t('3173',{str:index3+1})}}  </span>

								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#e97a72;" v-if="index3==3"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==3">{{$t('3173',{str:index3+1})}}  </span>

								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#292b65;" v-if="index3==4"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==4">{{$t('3173',{str:index3+1})}}  </span>

								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#68cec6;" v-if="index3==5"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==5">{{$t('3173',{str:index3+1})}} </span>
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#f5d479;" v-if="index3==6"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==6">{{$t('3173',{str:index3+1})}}  </span>
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#737acf;" v-if="index3==7"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==7">{{$t('3173',{str:index3+1})}}  </span>
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#e97a72;" v-if="index3==8"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==8">{{$t('3173',{str:index3+1})}}  </span>
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#292b65;" v-if="index3==9"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==9">{{$t('3173',{str:index3+1})}}  </span>
							</div>
						</div>
						<div class="mgl-100 pdl-48" v-if="graphvalue(answerChoice)">
							<doughnut-chart :chart-data="graphvalue(answerChoice)" :height="250" :width="290"></doughnut-chart>
						</div>
					</div>
					</div>
				</div>
				<!-- <div v-else>
					<div class="mgt-24 t-body6 mgt-16 t-color-bodyGrayA l-spacing-45 t-line-4-22">{{$t('3180')}}</div>
					<div class="mgt-24 d-flex">
						<div class="d-flex flex-column">
							<div class="d-flex align-items-center mgb-16">
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#68cec6;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22">{{$t('3173',{str:1})}} </span>
							</div>
							<div class="d-flex align-items-center mgb-16">
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#f5d479;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22">{{$t('3173',{str:2})}} </span>
							</div>
							<div class="d-flex align-items-center mgb-16">
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#737acf;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22">{{$t('3173',{str:3})}} </span>
							</div>
							<div class="d-flex align-items-center mgb-16">
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#e97a72;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22">{{$t('3173',{str:4})}} </span>
							</div>
							<div class="d-flex align-items-center mgb-16">
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#292b65;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22">{{$t('3173',{str:5})}} </span>
							</div>
						</div>
						<div class="mgl-100 pdl-48">
							  <img src="/images/survey/graph-two.png" alt="" >
						</div>
					</div>
				</div> -->
				</div>
			</div>
		</main>
	</div>
  </div>
  <div v-else>
			<div class="t-headline11 font-m l-spacing72 t-line-h-24">{{$t('1818')}}</div>
				<div class="d-flex align-items-center mgt-8 ">
					<img src="/images/survey/participant.svg" alt="" class="w-14 mgr-8">
					<span class="t-color-bodyGrayA t-body6 font-r l-spacing45 t-line-h-22" v-if="surveyData">
					  {{$t("1819", { str:surveyData.submitCount})}}
					</span>
				</div>
				<div v-for="(survey, index) in surveyData.stats" :key="index">
				<div class="mdc-card mgb-16 mgt-16 pda-24" v-if="survey && survey.questionType && (survey.questionType.value=='CHOICE_SINGLE' || survey.questionType.value=='CHOICE_MULTIPLE')" >
					<div class="t-headline7 font-r l-spacing54 t-line-h-24 d-flex -align-items-center">
					  {{index+1}}. {{survey.contents.text}}
					  <img src="/images/survey/survey-point.svg" alt="" class="pdl-4 w-7 d-inline" v-if="survey.essential=== true">
					</div>
					<div class="" v-for="(information, index1) in survey.statsDto[0].information" :key="index1">
						<div class="t-body6 mgt-18 t-color-bodyGrayA l-spacing-45 t-line-4-22">{{information.content}}</div>
						<div class="t-subtitle2 font-rb mgb-7 t-nowrap" v-if="information.rate>93" :style="`padding-left:calc(${information.rate}% - 50px);`">{{$t("1820", { str:information.rate})}}</div>
						<div class="t-subtitle2 font-rb mgb-7 t-nowrap" v-else :style="`padding-left:calc(${information.rate}%);`">{{$t("1820", { str:information.rate})}}</div>
						<div class="bg-iconInactiveText position-relative h-2 b-radius4">
							<div class="bg-iconInactive position-absolute h-6 survey-percentage" :style="`width: ${information.rate}%;`">
							</div>
						</div>
						<div class="t-body3 t-color-iconInactive mgt-15 d-flex justify-content-end font-r">
							{{$t("1821", { str1:information.count,str2:survey.statsDto[0].total})}}
						</div>
						<div class="mgt-16"> </div>
					</div>
				</div>
				<div class="mdc-card mgt-24 pda-24" v-if="survey && survey.questionType && survey.questionType.value=='SHORT_ANSWER'">
					<div class="t-headline7 font-r l-spacing54 t-line-h-24 d-flex -align-items-center">{{index+1}}. {{survey.contents.text}}
						<img src="/images/survey/survey-point.svg" alt="" class="pdl-4 w-7 d-inline" v-if="survey.essential=== true">
					</div>
					<div class="t-body6 mgt-16 t-color-bodyGrayA l-spacing-45 t-line-4-22">
					  {{$t('1822')}}
					</div>
				</div>
				<div class="mdc-card mgt-24" v-if="survey && survey.questionType && survey.questionType.value=='STARS'">
					<div class="pda-24">
						<div class="t-headline7 font-r l-spacing54 t-line-h-24 d-flex -align-items-center">
						  {{index+1}}. {{survey.contents.text}}<img
							src="/images/survey/survey-point.svg" alt="" class="pdl-4 w-7 d-inline" v-if="survey.essential=== true">
						</div>
						<div class="d-flex mgt-16">
							<div class="d-flex flex-column">
								<div class="pdl-2 font-rb survey-rank">{{survey.statsDto[0].avg}}</div>
								<div class="t-body3 t-color-bodyGrayA font-r l-spacing42 t-center mgt-8">{{$t('1823')}}</div>
							</div>
							<div class="flex-grow-1 d-flex flex-column">
								<div class="flex-grow-1 d-flex align-items-baseline mgl-10 h-6" v-for="(star, index2) in survey.statsDto[0].information" :key="index2">
									<div class="w-30 t-right">
									  <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-30 d-inline" v-if="star.rank==5">
									  <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-24 d-inline" v-if="star.rank==4">
									  <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-18 d-inline" v-if="star.rank==3">
									  <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-12 d-inline" v-if="star.rank==2">
									  <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-6 d-inline"  v-if="star.rank==1">
									</div>
									<div class="flex-grow-1 mgl-6">
										<div class="bg-iconInactiveText position-relative h-2 b-radius4">
											<div class="bg-iconInactive position-absolute h-2 star-percentage"
												:style="`width: ${star.count*20}%;`">
											</div>
										</div>
									</div>
								</div>
								<div class="flex-grow-1 d-flex align-items-baseline justify-content-end t-color-bodyGrayA t-body3 font-r mgt-24">
								   {{$t("1824", { str:survey.statsDto[0].total})}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mdc-card mgt-24 mgb-24 pda-24" v-if="survey && survey.questionType && survey.questionType.value=='RANKING'">
					<div class="t-headline7 font-r l-spacing54 t-line-h-24 d-flex -align-items-center">
					  {{index+1}}. {{survey.contents.text}}<img
							src="/images/survey/survey-point.svg" alt="" class="w-16 d-inline" v-if="survey.essential=== true">
					</div>
					<div v-for="(answerChoice, index2) in survey.statsDto" :key="index2">
					<div class="t-body6 mgt-16 t-color-bodyGrayA l-spacing-45 t-line-4-22">{{answerChoice.choiceAnswerName}}</div>
					<div class="mgt-24 d-flex" v-if="answerChoice && answerChoice.information && answerChoice.information.length>0">
						<div class="d-flex flex-column">
							<div class="d-flex align-items-center mgb-16"  v-for="(informationRank, index3) in answerChoice.information" :key="index3">
								<span class="mgr-16 w-41 h-6 b-radius2"  v-if="index3==0" style="background:#68cec6;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22"  v-if="index3==0">{{$t('3173',{str:index3+1})}} </span>
						   
								<span class="mgr-16 w-41 h-6 b-radius2" v-if="index3==1" style="background:#f5d479;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==1">{{$t('3173',{str:index3+1})}}  </span>

								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#737acf;" v-if="index3==2"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==2">{{$t('3173',{str:index3+1})}}  </span>

								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#e97a72;" v-if="index3==3"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==3">{{$t('3173',{str:index3+1})}}  </span>

								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#292b65;" v-if="index3==4"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==4">{{$t('3173',{str:index3+1})}}  </span>

								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#68cec6;" v-if="index3==5"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==5">{{$t('3173',{str:index3+1})}} </span>
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#f5d479;" v-if="index3==6"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==6">{{$t('3173',{str:index3+1})}}  </span>
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#737acf;" v-if="index3==7"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==7">{{$t('3173',{str:index3+1})}}  </span>
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#e97a72;" v-if="index3==8"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==8">{{$t('3173',{str:index3+1})}}  </span>
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#292b65;" v-if="index3==9"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22" v-if="index3==9">{{$t('3173',{str:index3+1})}}  </span>
							</div>
							
						</div>
						<div class="mgl-100 pdl-48" v-if="graphvalue(answerChoice)">
							<doughnut-chart :chart-data="graphvalue(answerChoice)" :height="250" :width="290"></doughnut-chart>
						</div>
					</div>
					</div>
				</div>
				<!-- <div v-else>
					<div class="mgt-24 t-body6 mgt-16 t-color-bodyGrayA l-spacing-45 t-line-4-22">{{$t('3180')}}</div>
					<div class="mgt-24 d-flex">
						<div class="d-flex flex-column">
							<div class="d-flex align-items-center mgb-16">
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#68cec6;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22">{{$t('3173',{str:1})}} </span>
							</div>
							<div class="d-flex align-items-center mgb-16">
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#f5d479;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22">{{$t('3173',{str:2})}} </span>
							</div>
							<div class="d-flex align-items-center mgb-16">
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#737acf;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22">{{$t('3173',{str:3})}} </span>
							</div>
							<div class="d-flex align-items-center mgb-16">
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#e97a72;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22">{{$t('3173',{str:4})}} </span>
							</div>
							<div class="d-flex align-items-center mgb-16">
								<span class="mgr-16 w-41 h-6 b-radius2" style="background:#292b65;"></span> <span
									class="t-body3 t-color-bodyGrayB l-spacing42 t-line-h-22">{{$t('3173',{str:5})}} </span>
							</div>
						</div>
						<div class="mgl-100 pdl-48">
							<span class="t-helper t-color-bodyGrayA position-absolute">{{$t('3180')}}</span>
							  <img src="/images/survey/graph-two.png" alt="" >
						</div>
					</div>
				</div> -->
				</div>
			</div>
</template>

<script>
/**
 * 단독 설문 상세 메인 컴포넌트(independent survey view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import campaignApi from "@/api/campaignApi.js";
import ViewHeaderInsight from "./view/InsightHeader";
// import ViewInformation from "./view/Information";
// import ViewReward from "./view/Reward";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import TopAppBar from "../TopAppBar.vue";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import { surveyMixin } from "@/mixins/survey.js";
import DoughnutChart from "./charts/DoughnutChart";
//import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";

export default {
  name:"InsightView",
  data() {
			return {
					surveyData: null,
					badgesData: null,
					campaignData: null,
					setTabFixed: false,
					graphResult: null,
					title:localStorage.getItem('brandName')
			};
  },
  components: {
			"view-header-insight": ViewHeaderInsight,
			DoughnutChart,
			topAppBarMixin,
			TopAppBar,
			TopAppBarDrawer
  },
props:['headerType'],
  mixins: [surveyMixin, topAppBarMixin],
  mounted() {
			this.fatchData();
  },

  methods: {
			graphvalue(content) {
					let temData = content.information.map(arr=>{
						return arr.rate
					})
					return this.setGraphData(temData)
			},
	setGraphData(temData){
	   let finalResult = {
					labels: ["Rank1",	"Rank2",	"Rank3",	"Rank4", "Rank5","Rank6",	"Rank7",	"Rank8",	"Rank9", "Rank10"],
					datasets: [{
								borderWidth: 1,
								backgroundColor: [
								"#68cec6", "#f5d479", "#737acf",'#e97a72','#292b65',"#68cec6", "#f5d479", "#737acf",'#e97a72','#292b65'                
								],
								data: temData,
						}],
						};
						return finalResult
	},
	// 상세 데이터 호출(get survey information data)
	async fatchData() {
	  let params = {
		distributionId: this.$route.params.distId,
	  };

	  // check auth & get survey information data
	  let authStatus = await this.checkLogin();
	  if (authStatus) {
				surveyApi.surveyInsightView(params).then((response) => {
						this.surveyData = response.data.data;
				});
	  } 

	  
	  // get survey campaign data
	  campaignApi
		.campaign({
		  locationType: "IN_INDEPENDENT_SURVEY",
		  locationValue: this.$route.params.distId,
		})
		.then((response) => {
		  this.campaignData = response.data.data;
		})
		.catch((err) => {});
	},

		// 상하 스크롤 이동시 탭 고정(move up/down scroll fixed tab)
		scrollMove(el) {
			if ( parseInt(el.scrollTop) >= parseInt(this.$refs.surveyHeader.offsetHeight) ) {
				this.setTabFixed = true;
			} 
			else {
					this.setTabFixed = false;
			}
		},
	},
};
</script>